import { UntypedFormGroup, UntypedFormControl, Validators, FormControl, FormGroup } from '@angular/forms';

export enum ResetPasswordFields {
    Password = 'Password',
    RepeatNewPassword = 'RepeatNewPassword'
}

export interface ResetPasswordForm {
    [ResetPasswordFields.Password]: FormControl<string>,
    [ResetPasswordFields.RepeatNewPassword]: FormControl<string>
}

export const generateResetPasswordForm = (): FormGroup<ResetPasswordForm> => {
    return new FormGroup<ResetPasswordForm>({
        [ResetPasswordFields.Password]: new FormControl('', {nonNullable: true, validators: [Validators.required, Validators.minLength(6)]} ),
        [ResetPasswordFields.RepeatNewPassword]: new FormControl('', {nonNullable: true, validators: [Validators.required, Validators.minLength(6)]}),
    });
};
